import { useContext } from 'react';
import classnames from 'classnames';
import { Text } from "../../Text/Text/Text";
import { ThemeContext } from "../../../context/theme.context";
import styles from "./ZipTextPrice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ZipTextPrice = function ZipTextPrice(_ref) {
  var text = _ref.text,
    _ref$zipAriaLabel = _ref.zipAriaLabel,
    zipAriaLabel = _ref$zipAriaLabel === void 0 ? 'clicking this button will open a form to select a new zipcode.' : _ref$zipAriaLabel,
    _ref$onClick = _ref.onClick,
    onClickInit = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$zipClassName = _ref.zipClassName,
    zipClassName = _ref$zipClassName === void 0 ? '' : _ref$zipClassName,
    _ref$stopPropagation = _ref.stopPropagation,
    stopPropagation = _ref$stopPropagation === void 0 ? false : _ref$stopPropagation,
    _ref$typog = _ref.typog,
    typog = _ref$typog === void 0 ? 'bodycopy' : _ref$typog,
    zipOrLocation = _ref.zipOrLocation;
  var theme = useContext(ThemeContext);
  var onClick = function onClick(event) {
    event.preventDefault();
    if (stopPropagation) {
      event.stopPropagation();
    }
    onClickInit(event);
  };
  return /*#__PURE__*/_jsxs(Text, {
    className: classnames(styles.zipTextPrice, className),
    typog: typog,
    childrenInline: true,
    children: [text, /*#__PURE__*/_jsx("span", {
      onClick: onClick,
      "aria-label": zipAriaLabel,
      className: classnames(styles.zipTextPriceZip, zipClassName, {
        [styles.zipTextPriceZipDarkBackground]: theme === 'darkBackground',
        [styles.zipTextPriceZipBodycopy]: typog === 'bodycopy'
      }),
      role: "button",
      tabIndex: 0,
      children: zipOrLocation
    })]
  });
};